import { template as template_6a46e6a6bc6c42d891605032b494d7ea } from "@ember/template-compiler";
import AttachTooltip from 'ember-attacher/components/attach-tooltip';
import svgJar from 'ember-svg-jar/helpers/svg-jar';
import t from 'ember-intl/helpers/t';
export default template_6a46e6a6bc6c42d891605032b494d7ea(`
  <span class="tooltip-wrapper" aria-label={{t "shared.accessibility.helpLabel"}}>
    {{svgJar "help" class="icon" aria-hidden="true"}}
    <AttachTooltip @class="tooltip align-left">
      {{yield}}
    </AttachTooltip>
  </span>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
